import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function PhoneIcon(props) {
  return (
    <SvgIcon viewBox="0 0 61 60" {...props}>
      <title>Phone</title>
      <g>
        <path d="M9.10074 25.1939C6.19755 19.9305 5.09082 15.6872 5.09082 12.8212C5.09082 9.95522 5.79497 9.13321 6.5095 8.46914C7.22402 7.80507 10.446 5.81861 10.995 5.44814C11.544 5.07767 13.6392 4.3577 14.9532 6.24787C16.2672 8.13803 18.7415 11.9331 20.4475 14.4542C23.1244 18.0252 20.9917 19.5928 20.3029 20.5323C19.0353 22.2613 18.3054 22.6877 18.3054 24.8107C18.3054 26.9336 24.2385 32.9651 25.6572 34.4511C27.0651 35.9259 32.9769 41.1084 34.8088 41.3856C36.6536 41.6647 39.1232 39.7116 39.6483 39.2163C42.3194 37.1656 43.8271 38.7204 45.0575 39.3962C46.2879 40.072 51.8469 43.536 53.5696 44.7036C55.1909 45.8712 55.0896 47.6758 55.0896 47.6758C55.0896 47.6758 51.7455 52.9832 51.3402 53.6201C50.8335 54.3631 49.6175 55 46.8815 55C44.1455 55 41.2222 54.5003 34.2748 50.6795C28.5902 47.5532 23.1712 42.6576 20.3338 39.7916C17.3951 36.9256 12.417 31.2062 9.10074 25.1939Z" />
      </g>
    </SvgIcon>
  );
}

export default PhoneIcon;
